import { createAction, props } from '@ngrx/store';

export const selectDeliveryDate = createAction(
  '[Calendar] Set Selected Delivery Date',
  props<{ selectedDate: string }>()
);

export type SelectedDeliveryDateActions = typeof selectDeliveryDate;
